'use client';

import { useMergeRefs } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { Slot } from '../slot';
import { TriggerButton } from '../trigger-button/trigger-button';
import { PopoverRootContext } from './context/popover-root.context';
import type { PopoverTriggerPropsInterface } from './types/popover-trigger.types';

/**
 * @since 10.0.0
 */
export const PopoverTrigger = forwardRef<HTMLButtonElement, PopoverTriggerPropsInterface>(
  (props: PopoverTriggerPropsInterface, forwardedRef) => {
    const { children = <TriggerButton />, ...rest } = props;
    const { popover } = useContext(PopoverRootContext);
    const mergedRefs = useMergeRefs([popover.refs.setReference, forwardedRef]);

    return (
      <Slot
        ref={mergedRefs}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Popover.Trigger"
        {...popover.getReferenceProps(rest)}
      >
        {children}
      </Slot>
    );
  },
);

PopoverTrigger.displayName = 'Popover.Trigger';
